'use client';

const YandexMap = () => {
    return (
        <div className="map_wrapper" style={{ height: '400px', width: '100%' }}>
            <iframe
                src="https://yandex.ru/map-widget/v1/?um=constructor%3Ac20192dddd70b2cb9c667dab260e64e5d59137b5ba43bd8e5c6da599e57c2f92&amp;source=constructor"
                width="100%"
                height="400"
                frameBorder="0"
                title="Yandex Map"
            ></iframe>
        </div>
    );
};
export default YandexMap;
